import React from 'react';
import productnames from '../Assets/Data/productnames.json'; 
import logo from '../Assets/images/Union.png';

const Products = () => {
  return (
    <div className='product-names'>
    <div className="marquee-container">
      <div className="marquee">
        <div className="marquee-track">
        {productnames.map((item, index) => (
    <span class="ml-3 text-xl">{item.item}  <img src={logo} alt='logo' class="ml-3"></img>
  </span>
  ))}
          {/* Duplicate set */}
          {productnames.map((item, index) => (
    <span class="ml-3 text-xl">{item.item}<img src={logo} alt='logo' class="ml-3"></img></span>
  ))}
        </div>
      </div>
    </div>
    </div>
  )
}

export default Products